import { AxiosResponse } from "axios";
import apiClient, { CustomAxiosRequestConfig } from "../../shared/utils/apiClient";

export interface UserProfileProps {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  roleName: string;
  verified: string;
}

interface LoginResponse {
  token: string;
  user: UserProfileProps;
}

export const getOrganizationByExtension = (
  organizationExtension: string
): Promise<AxiosResponse<LoginResponse>> => {
  const response = apiClient.get<LoginResponse>(
    `organizations/${organizationExtension}`,
    { requiresAuth: true } as CustomAxiosRequestConfig // Use the custom type here
  );
  return response;
};

export const getAllOrganizations = (
  ): Promise<AxiosResponse<LoginResponse>> => {
    const response = apiClient.get<LoginResponse>(
      `organizations`,
      { requiresAuth: true } as CustomAxiosRequestConfig // Use the custom type here
    );
    return response;
};